import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styles from './BetaBanner.module.css';

const STORAGE_KEY = 'betaBannerCollapsed';

function BetaBanner() {
  const { t } = useTranslation();
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'true';
    } catch (e) {
      return false;
    }
  });

  const setAndStore = (value) => {
    setCollapsed(value);
    try {
      localStorage.setItem(STORAGE_KEY, String(value));
    } catch (e) {
      // localStorage nicht verfügbar - Zustand gilt nur für diese Session
    }
  };

  if (collapsed) {
    return (
      <button type="button" className={styles.collapsedIcon} onClick={() => setAndStore(false)} title={t('betaBanner.expand')} aria-label={t('betaBanner.expand')}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
        </svg>
      </button>
    );
  }

  return (
    <div className={styles.banner}>
      <div className={styles.inner}>
        <div className={styles.iconWrap}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
          </svg>
        </div>
        <div className={styles.textBlock}>
          <p className={styles.text}>
            <span className={styles.badge}>{t('betaBanner.badge')}</span>{' '}
            <Trans i18nKey="betaBanner.text" components={[<strong key="0" />, <strong key="1" />, <strong key="2" />]} />
          </p>
        </div>
        <button type="button" className={styles.dismissBtn} onClick={() => setAndStore(true)} title={t('betaBanner.collapse')} aria-label={t('betaBanner.collapse')}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"><path d="M4 8h8"/></svg>
        </button>
      </div>
    </div>
  );
}

export default BetaBanner;
